import React, { useState } from 'react';

import { historyPropType } from '~/config/routerPropTypes';
import { createChat, editChat } from '~/config/routes';
import Request from '~/providers/Request';
import ChatRecord from '~/records/ChatRecord';

import Form from './FormNew';

function NewRecord({ history }) {
  const [record, setRecord] = useState(new ChatRecord());
  const [loading, setLoading] = useState(false);

  async function onSubmit(saveAndContinue) {
    const data = record.toParams();
    Request.post('/admin/chats', data, {}, { controller: 'chats' })
      .then((resp) => {
        setLoading(false);
        if (saveAndContinue) {
          history.push(createChat.spec);
        } else {
          history.push(editChat.reverse(resp.data));
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

NewRecord.propTypes = {
  history: historyPropType,
};

export default NewRecord;
